import * as React from 'react';
import { useMapEvent } from '../..';
var MapOnClick = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    var handleClick = React.useCallback(function (e) {
        if (disabled) {
            return;
        }
        onClick(e);
    }, [onClick, disabled]);
    useMapEvent('click', handleClick);
    return null;
};
export default React.memo(MapOnClick);
